'use strict';
const angular = require('angular');

import { IOptionsService, ISeason } from '../../interfaces';

let ACTIVE_SEASON_FIELD = 'activeSeason';
const OPEN_REGISTRATIONS_SEASON_FIELD = 'openRegistrationsSeason';

export class OptionsService implements IOptionsService{
  $http: ng.IHttpService;
  activeDeferred: ng.IDeferred<any>;
  openRegistrationsDeferred: ng.IDeferred<any>;
  $q: ng.IQService;

  /*@ngInject*/
  constructor($http, $q: ng.IQService) {
    this.$http = $http;
    this.$q = $q;
    this.activeDeferred = this.$q.defer();
    this.openRegistrationsDeferred = this.$q.defer();
    this.reload();
  }

  public reload() {
    
    // Request for active season
    this.$http.get("/api/options/"+ACTIVE_SEASON_FIELD)
    .then(res => {
      if (res.data !== "") {
        this.$http.get("/api/seasons/" + res.data)
        .then(activeSeason => {
          this.activeDeferred.resolve(activeSeason.data);
        });
      } else {
        this.activeDeferred.resolve(res.data);
      }
    }, reason => {
      //this.setActiveSeason(null);
      this.activeDeferred.reject();
    });

    // Request for open registration season
    this.$http.get("/api/options/"+OPEN_REGISTRATIONS_SEASON_FIELD)
    .then(res => {
      if (res.data !== "") {
        this.$http.get("/api/seasons/" + res.data)
        .then(registrationSeason => {
          this.openRegistrationsDeferred.resolve(registrationSeason.data);
        });
      } else {
        this.openRegistrationsDeferred.resolve(res.data);
      }
      
    }, reason => {
      this.openRegistrationsDeferred.reject();
      //this.setOpenRegistrationsSeason(null);
      /*
      if (err.status === 404) {
        this.setOpenRegistrationsSeason(null);
      } else {
        this.openRegistrationsDeferred.reject();
      } */
    });
  }

  public getActiveSeason() {
    return this.activeDeferred.promise;
  }

  public setActiveSeason(season: ISeason) {
    let activeSeasonId = season ? season._id : '';

    this.activeDeferred = this.$q.defer();
    return this.$http.post("/api/options/"+ACTIVE_SEASON_FIELD, {value: activeSeasonId})
    .then(() => {
      this.reload();
    });
  }

  public getOpenRegistrationsSeason() {
    return this.openRegistrationsDeferred.promise;
  }

  public setOpenRegistrationsSeason(season: ISeason) {
    let openRegistrationId = season ? season._id : '';

    this.openRegistrationsDeferred = this.$q.defer();
    return this.$http.post("/api/options/"+OPEN_REGISTRATIONS_SEASON_FIELD, {value: openRegistrationId})
    .then(() => {
      this.reload();
    });
  }

  /* public addOpenRegistrationsSeason(season: ISeason) {
    if (season) {
      return this.getOpenRegistrationsSeason()
      .then( seasonIds => {
        if (seasonIds && seasonIds.indexOf(season._id) < 0) {
          seasonIds.push(season._id);
        }
        return this.$http.post("/api/options/"+OPEN_REGISTRATIONS_SEASON_FIELD, {value: seasonIds})
        .then(() => {
          this.reload();
        });
      });
    }
  } 

  public removeOpenRegistrationsSeason(season: ISeason) {
    if (season) {
      return this.getOpenRegistrationsSeason()
      .then(seasonIds => {
        if (seasonIds && seasonIds.indexOf(season._id)>-1) {
          seasonIds.splice(seasonIds.indexOf(season._id), 1);
        }
        this.openRegistrationsDeferred = this.$q.defer();
        return this.$http.post("/api/options/"+OPEN_REGISTRATIONS_SEASON_FIELD, {value: seasonIds})
        .then(() => {
          this.reload();
        });
      });
    }
  }*/
}

export default angular.module('terrappApp.OptionsService', [])
  .service('OptionsService', OptionsService)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/optionsService/optionsService.service.ts